/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import { pathConstants } from "@/shared/pathConstants";
import { cloneDeep } from "lodash";
import Vue from "vue";
import store from "@/store";
import { queryConstant } from "@/shared/queryConstant";

const allAgences = function(pagedFilter, showLoader = true) {
  const customPagedFilter = cloneDeep(pagedFilter);
  if (customPagedFilter.myPager.page > 1) {
    customPagedFilter.myPager.page = customPagedFilter.myPager.page - 1;
  } else {
    customPagedFilter.myPager.page = 0;
  }
  return axios
    .post(pathConstants.API + "/agences/clientAgences", customPagedFilter, {
      showLoader
    })
    .then(response => response.data)
    .catch(error => error);
};

const allAgencesList = function() {
  return axios
    .get(pathConstants.API + "/agences/clientAgences")
    .then(response => response.data)
    .catch(error => error);
};

const allUserAgencesList = function(pagedFilter) {
  let customPagedFilter = {
    myPager: null,
    search: "",
    customFilter: queryConstant.setDefaultCustomFilter()
  };
  if (pagedFilter) {
    customPagedFilter = cloneDeep(pagedFilter);
  }
  if (customPagedFilter.myPager && customPagedFilter.myPager.page > 1) {
    customPagedFilter.myPager.page = customPagedFilter.myPager.page - 1;
  } else if (customPagedFilter.myPager) {
    customPagedFilter.myPager.page = 0;
  }
  return axios
    .post(pathConstants.API + "/agences/userAgences", customPagedFilter)
    .then(response => response.data)
    .catch(error => error);
};

const changeActivation = function(activationAgenceDto) {
  store.commit("loader/showActivateAgenceLoader");
  store.commit("agence/setShouldLoading", activationAgenceDto.id);
  return axios
    .post(
      pathConstants.API + "/agences/activateAgence",
      { id: activationAgenceDto.id, isEnable: activationAgenceDto.isEnabled },
      { showLoader: false }
    )
    .then(response => response.data)
    .catch(error => {
      Vue.$log.error("changeActivation", error);
    })
    .finally(() => {
      store.commit("loader/hideActivateAgenceLoader");
      store.commit("agence/setShouldNotLoading", activationAgenceDto.id);
    });
};

const fetchAgenceById = function(id) {
  return axios.get(`${pathConstants.API}/agences/getAgenceById?id=` + id).then(
    result => result.data,
    err => {
      Vue.$log.error("fetchAgenceById", err);
    }
  );
};

const addAgence = function(agenceDto) {
  return axios.post("/api/agences/addAgence", agenceDto).then(
    result => {
      if (result.data) {
        return result.data;
      } else {
        return {};
      }
    },
    err => {
      Vue.$log.error("addAgence", err);
    }
  );
};

const modifyAgence = function(agenceDto) {
  return axios.post("/api/agences/modifyAgence", agenceDto).then(
    result => {
      if (result.data) {
        return result.data;
      } else {
        return {};
      }
    },
    err => {
      Vue.$log.error("modifyAgence", err);
    }
  );
};

const fetchAgencyInfosBySiret = function(siret) {
  return axios
    .get(pathConstants.API + `/agences/getAgenceInfosBySiret?siret=${siret}`, {
      showLoader: false
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("getInfosAgencyBySiret", err);
      }
    );
};
const checkSiretExists = function(siret) {
  return axios
    .get("/api/agences/checkSiret", { params: { siret } })
    .then(response => response.data)
    .catch(() => false);
};
const fetchCitiesByPostalCode = function(postalCode) {
  return axios
    .get(
      pathConstants.API +
        `/agences/getCityByPostalCode?postalCode=${postalCode}`,
      { showLoader: false }
    )
    .then(result => {
      return result.data;
    })
    .catch(error => {
      console.error(error);
      return [];
    });
};
export const agenceService = {
  allAgences,
  allAgencesList,
  allUserAgencesList,
  addAgence,
  fetchAgenceById,
  modifyAgence,
  changeActivation,
  fetchAgencyInfosBySiret,
  checkSiretExists,
  fetchCitiesByPostalCode
};
